import { Switch } from "@mui/material";
import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";

type WorksheetRowLinkToggleProps = {
  name: string;
  rowUuid: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

export default function WorksheetRowLinkToggle({
  name,
  rowUuid,
  checked,
  disabled,
  onChange,
}: WorksheetRowLinkToggleProps) {
  return (
    <MDBox
      key={`${rowUuid}-toggle`}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap="8px"
      minWidth={0}
    >
      <UiTypography
        uiVariant="body-sm"
        sx={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}
      >
        {name || "Hourly cost"}
      </UiTypography>
      <Switch
        size="small"
        checked={checked}
        disabled={disabled}
        sx={{ flexShrink: 0 }}
        onChange={(event) => onChange(event.target.checked)}
      />
    </MDBox>
  );
}
